import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { navigationGroups, activeNavigation } from './navigationModel';
import './Sidebar.css';

export default function Sidebar({ month, onNavigate }) {
  const { user, token } = useAuth();
  const canLoadTeamNavigation = user?.role === 'superadmin' || user?.role === 'admin';
  const { pathname } = useLocation();
  const [salespeople, setSalespeople] = useState([]);
  const tabsRef = useRef(null);
  const sectionsRef = useRef(null);
  useEffect(() => {
    let disposed = false;
    // Only staff navigation uses the team list (for commission/invoice links),
    // and the overview endpoint is staff-only. Non-staff roles must not call it.
    if (token && canLoadTeamNavigation) {
      axios.get(`/api/dashboard/overview?month=${month}`, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          const order = ['Ginny', 'Zac', 'JQ', 'Zen'];
          if (!disposed) setSalespeople((response.data.salespeople || []).filter(person => order.includes(person.name)).sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name)));
        }).catch(error => console.error('Failed to fetch salespeople for navigation', error));
    }
    return () => { disposed = true; };
  }, [month, token, canLoadTeamNavigation]);

  const groups = navigationGroups(user, salespeople);
  const { group: activeGroup, page: activePage } = activeNavigation(groups, pathname);
  useEffect(() => {
    // Keep a directly opened page's tab visible on narrow screens, without scrolling the page.
    for (const row of [sectionsRef.current, tabsRef.current]) {
      const current = row?.querySelector('[aria-current]');
      if (current && row) row.scrollLeft = Math.max(0, current.offsetLeft - 16);
    }
  }, [pathname, salespeople]);
  const initials = user?.name?.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2) || '??';

  return <header id="primary-sidebar" className="sidebar lilac-navigation" onClick={event => { if (event.target.closest('a')) onNavigate?.(); }}>
    <div className="sidebar-brand">
      <div className="sidebar-logo">rm</div>
      <div className="sidebar-brand-text"><h2>RunningMen</h2></div>
    </div>
    <nav ref={sectionsRef} className="primary-sections" aria-label="Main navigation">
      {groups.map(group => <Link key={group.label} to={group.pages[0].to} className={`section-tab ${activeGroup === group ? 'active' : ''}`} aria-current={activeGroup === group ? 'true' : undefined}>{group.label}</Link>)}
    </nav>
    <nav ref={tabsRef} className="page-tabs" aria-label={`${activeGroup.label} pages`}>
      {activeGroup.pages.map(page => <Link key={page.to} to={page.to} className={`page-tab ${activePage === page ? 'active' : ''}`} aria-current={activePage === page ? 'page' : undefined}>{page.label}</Link>)}
    </nav>
    {user && <div className="sidebar-footer"><div className="sidebar-user">
      <div className="sidebar-avatar">{initials}</div>
      <div className="sidebar-user-info"><div className="u-name">{user.name}</div><div className="u-role">{user.role}</div></div>
    </div></div>}
  </header>;
}
